import createLinkifyPlugin from 'draft-js-linkify-plugin';
import { createBasePlugin, decorateComponentWithProps, } from 'wix-rich-content-common';
import { EXTERNAL_LINK_TYPE } from './types';
import { Strategy, Link } from './LinkDecorator';
import styles from './link-viewer.scss';
import createLinkToolbar from './toolbar/createLinkToolbar';
var createLinkPlugin = function (config) {
    if (config === void 0) { config = {}; }
    var type = EXTERNAL_LINK_TYPE;
    var _a = config, decorator = _a.decorator, helpers = _a.helpers, theme = _a.theme, isMobile = _a.isMobile, t = _a.t, anchorTarget = _a.anchorTarget, relValue = _a.relValue, getEditorState = _a.getEditorState, setEditorState = _a.setEditorState;
    var plugin = createLinkifyPlugin({
        target: anchorTarget,
        rel: relValue,
        theme: theme || styles,
    });
    var toolbar = createLinkToolbar({
        helpers: helpers,
        theme: theme,
        isMobile: isMobile,
        t: t,
        anchorTarget: anchorTarget,
        relValue: relValue,
        getEditorState: getEditorState,
        setEditorState: setEditorState,
    });
    plugin.decorators.push({
        strategy: Strategy,
        component: decorateComponentWithProps(Link, {
            className: theme.link,
            anchorTarget: anchorTarget,
            relValue: relValue,
        }),
    });
    return createBasePlugin({
        decorator: decorator,
        theme: theme,
        toolbar: toolbar,
        type: type,
        helpers: helpers,
        isMobile: isMobile,
        anchorTarget: anchorTarget,
        relValue: relValue,
        t: t,
    }, plugin);
};
export { createLinkPlugin };
//# sourceMappingURL=createLinkPlugin.js.map